// extracted by mini-css-extract-plugin
export default {"authLayout":"auth_authLayout__YL69-","layoutWrapper":"auth_layoutWrapper__I6Sju","layoutForm":"auth_layoutForm__Pq43P"};